import { compose } from "redux";
import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";
import { IAction } from "../../../models/Action";
import { immutableSet } from "../../../utils/immutable";
import { formatDateFromMillisecondsStringToDDMMYYYY } from "../../../utils/utils";
import { actionTypes } from "./actions";
import {
  IComboOptionType,
  IExternalPortalUserType,
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
  STATE_IDENTIFIER,
  statusCodeId,
  statusDescCode,
  statusIdCode,
  statusIdLowerCase,
} from "./constants";
import emptyState from "./emptyState";

const {
  ROLES,
  SELECTED_ROLE,
  COMPACTED_USERS,
  USERS_MANAGEMENT,
  STEP_ONE,
  REQUEST_STATE,
  SELECTED_USERS,
  STEP_TWO,
  USER_DETAIL,
  SOCIETY_VALIDATION,
  USERS,
  OFFICES,
  COMPANIES,
  ADD_USER,
  ALREADY_EXISTING_FISCAL_CODE,
  FIELD_VISIBILITY,
  BUTTONS,
  MANAGERS,
  REFERRALS,
  ORGANIZATIONAL_UNITS,
  COMBO_OPTIONS,
  CLUSTER,
  CONTRACT_TYPOLOGY,
  FTE,
  PRESENCE,
  REACTIVATE_RENEW_ADMIN_BODY,
  REACTIVATE_RENEW_MASSIVE_BODY,
  ADD_USER_RESPONSE_STATE,
  ATTACHMENTS,
  ADMIN_LETTERS,
  OU_SELECTED_ROLES,
  USER_TYPES_THAT_CAN_BE_CREATED,
  MANIPOLATED_OU,
  FAILED_OPERATIONS,
  USERS_WITH_SAME_FISCAL_CODE_MANAGER,
} = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.GET_FIELD_VISIBILITY]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, FIELD_VISIBILITY, LOADER_IDENTIFIER],
      true,
      state
    ),

  [actionTypes.GET_FIELD_VISIBILITY_SUCCESS]: (state: any, action: any) => {
    let mappedResponse = [] as any[];
    action.payload.length > 0 &&
      action.payload.forEach((e: any) => mappedResponse.push(e));
    return compose(
      immutableSet(
        [USERS_MANAGEMENT, FIELD_VISIBILITY, LIST_IDENTIFIER],
        mappedResponse
      ),
      immutableSet(
        [USERS_MANAGEMENT, FIELD_VISIBILITY, LOADER_IDENTIFIER],
        false
      )
    )(state);
  },

  [actionTypes.GET_FIELD_VISIBILITY_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, FIELD_VISIBILITY, LOADER_IDENTIFIER],
      false,
      state
    ),

  [actionTypes.GET_BUTTONS]: (state: any, action: any) =>
    immutableSet([USERS_MANAGEMENT, BUTTONS, LOADER_IDENTIFIER], true, state),

  [actionTypes.GET_BUTTONS_SUCCESS]: (state: any, action: any) => {
    let mappedResponse = [] as any[];
    action.payload.length > 0 &&
      action.payload.forEach((e: any) => mappedResponse.push(e));
    return compose(
      immutableSet(
        [USERS_MANAGEMENT, BUTTONS, LIST_IDENTIFIER],
        mappedResponse
      ),
      immutableSet([USERS_MANAGEMENT, BUTTONS, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.GET_BUTTONS_FAILURE]: (state: any, action: any) =>
    immutableSet([USERS_MANAGEMENT, BUTTONS, LOADER_IDENTIFIER], false, state),

  [actionTypes.GET_MANAGERS]: (state: any, action: any) =>
    compose(immutableSet([MANAGERS, LOADER_IDENTIFIER], true))(state),

  [actionTypes.GET_MANAGERS_SUCCESS]: (state: any, action: any) => {
    let mappedResponse = [] as any[];
    action.payload.length > 0 &&
      action.payload.forEach((user: any) => {
        let toAdd: any = {
          code: user.code,
          name: user.name,
          surname: user.surname,
          dipenId: user.dipen_id,
          organizational_unit_code: user.organizational_unit_code,
        };
        mappedResponse.push(toAdd);
      });

    return compose(
      immutableSet([MANAGERS, LIST_IDENTIFIER], mappedResponse),
      immutableSet([MANAGERS, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.GET_MANAGERS_FAILURE]: (state: any, action: any) =>
    compose(immutableSet([MANAGERS, LOADER_IDENTIFIER], false))(state),

  [actionTypes.GET_REFERRALS]: (state: any, action: any) =>
    compose(immutableSet([REFERRALS, LOADER_IDENTIFIER], true))(state),

  [actionTypes.GET_REFERRALS_SUCCESS]: (state: any, action: any) => {
    let mappedResponse = [] as any[];
    action.payload.length > 0 &&
      action.payload.forEach((user: any) => {
        let toAdd: any = {
          code: user.code,
          name: user.name,
          surname: user.surname,
          organizational_unit_code: user.organizational_unit_code,
        };
        mappedResponse.push(toAdd);
      });

    return compose(
      immutableSet([REFERRALS, LIST_IDENTIFIER], mappedResponse),
      immutableSet([REFERRALS, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.GET_REFERRALS_FAILURE]: (state: any, action: any) =>
    compose(immutableSet([REFERRALS, LOADER_IDENTIFIER], false))(state),

  [actionTypes.GET_ORGANIZATIONAL_UNITS]: (state: any, action: any) =>
    compose(immutableSet([ORGANIZATIONAL_UNITS, LOADER_IDENTIFIER], true))(
      state
    ),

  [actionTypes.GET_ORGANIZATIONAL_UNITS_SUCCESS]: (state: any, action: any) => {
    let mappedResponse = [] as any[];
    action.payload.length > 0 &&
      action.payload.forEach((e: any) => mappedResponse.push(e));
    return compose(
      immutableSet([ORGANIZATIONAL_UNITS, LIST_IDENTIFIER], mappedResponse),
      immutableSet([ORGANIZATIONAL_UNITS, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.GET_ORGANIZATIONAL_UNITS_FAILURE]: (state: any, action: any) =>
    immutableSet([ORGANIZATIONAL_UNITS, LOADER_IDENTIFIER], false, state),

  [actionTypes.GET_ORGANIZATIONAL_UNITS_BY_SELECTED_ROLES]: (
    state: any,
    action: any
  ) =>
    compose(immutableSet([OU_SELECTED_ROLES, LOADER_IDENTIFIER], true))(state),

  [actionTypes.GET_ORGANIZATIONAL_UNITS_BY_SELECTED_ROLES_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let mappedResponse = [] as any[];
    action.payload.length > 0 &&
      action.payload.forEach((e: any) => mappedResponse.push(e));
    return compose(
      immutableSet([OU_SELECTED_ROLES, LIST_IDENTIFIER], mappedResponse),
      immutableSet([ORGANIZATIONAL_UNITS, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.GET_ORGANIZATIONAL_UNITS_BY_SELECTED_ROLES_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([OU_SELECTED_ROLES, LOADER_IDENTIFIER], false, state),

  [actionTypes.GET_ALL_ROLES_REQUEST]: (state: any, action: any) =>
    immutableSet([ROLES, LOADER_IDENTIFIER], true, state),

  [actionTypes.GET_ALL_ROLES_REQUEST_SUCCESS]: (state: any, action: any) => {
    let mappedResponse = [] as any[];
    if (action.payload.length > 0) {
      for (var i = 0; i < action.payload.length; i++) {
        let temp = {
          id: i,
          roleName: action.payload[i],
        };
        mappedResponse.push(temp);
      }
    }
    return compose(
      immutableSet([ROLES, LIST_IDENTIFIER], mappedResponse),
      immutableSet([ROLES, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.GET_ALL_ROLES_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet([ROLES, LOADER_IDENTIFIER], false, state),

  [actionTypes.SET_ROLE_SELECTED_REQUEST]: (state: any, action: any) => {
    let mappedResponse = [] as any[];
    action.payload.length > 0 &&
      action.payload.forEach((data: any) => mappedResponse.push(data));
    return immutableSet([SELECTED_ROLE], action.payload, state);
  },

  [actionTypes.MODIFY_SELECTED_USERS]: (state: any, action: any) => {
    let mappedResponse = [] as any[];
    action.payload.length > 0 &&
      action.payload.forEach((data: any) => mappedResponse.push(data));
    return immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, SELECTED_USERS],
      mappedResponse,
      state
    );
  },

  [actionTypes.SET_USER_DETAIL]: (state: any, action: any) => {
    let mappedResponse = [] as any[];
    action.payload.length > 0 &&
      action.payload.forEach((data: any) => mappedResponse.push(data));
    return immutableSet(
      [USERS_MANAGEMENT, STEP_TWO, USER_DETAIL],
      mappedResponse,
      state
    );
  },

  [actionTypes.PAGINATED_USERS_REQUEST]: (state: any, action: any) =>
    compose(
      immutableSet([USERS_MANAGEMENT, STEP_ONE, LOADER_IDENTIFIER], true),
      immutableSet(
        [USERS_MANAGEMENT, ADD_USER, ALREADY_EXISTING_FISCAL_CODE],
        false
      ),
      immutableSet(
        [USERS_MANAGEMENT, ADD_USER, USERS_WITH_SAME_FISCAL_CODE_MANAGER],
        []
      )
    )(state),

  [actionTypes.PAGINATED_USERS_REQUEST_SUCCESS]: (state: any, action: any) => {
    let modifiedUsers1: any[] = [];
    let modifiedUsers2: any[] = [];
    let tempStatusId = "";
    let tempStatusDesc = "";
    let { users, ...paginationData } = action.payload;
    users.forEach((user: any) => {
      switch (user.statusId) {
        case statusIdLowerCase.In_Servizio:
          tempStatusId = statusIdCode.IN_SERVIZIO;
          tempStatusDesc = statusDescCode.IN_SERVIZIO;
          break;
        case statusIdLowerCase.in_Validazione:
          tempStatusId = statusIdCode.IN_VALIDAZIONE;
          tempStatusDesc = statusDescCode.IN_VALIDAZIONE;
          break;
        case statusIdLowerCase.Non_In_Servizio:
          tempStatusDesc = statusDescCode.NON_IN_SERVIZIO;
          if (user.userType === IExternalPortalUserType.CONSULTANT) {
            tempStatusId = statusIdCode.NON_IN_SERVIZIO_CONS;
          } else if (user.userType === IExternalPortalUserType.OUTSOURCER) {
            tempStatusId = statusIdCode.NON_IN_SERVIZIO_OUTS;
          }
          break;
        case statusIdLowerCase.Cessato:
          tempStatusDesc = statusDescCode.CESSATO;
          if (user.userType === IExternalPortalUserType.CONSULTANT) {
            tempStatusId = statusIdCode.CESSATO_CONS;
          } else if (user.userType === IExternalPortalUserType.OUTSOURCER) {
            tempStatusId = statusIdCode.CESSATO_OUTS;
          }
          break;
        default:
          tempStatusDesc = user.statusDesc;
          tempStatusId = user.statusId;
      }

      let modifiedUser1 = {
        id: user.id,
        userCode: user.userCode,
        ou: user.ou,
        userType: user.userType,
        name: user.name,
        surname: user.surname,
        fiscalCode: user.fiscalCode,
        isDisabled: user.isDisabled,
        isDeleted: user.isDeleted,
        email: user.email,
        dipenId: user.dipenId,
        dipenIdSec: user.dipenIdSec,
        companyId:
          user.userType === IExternalPortalUserType.OUTSOURCER
            ? null
            : user.companyId,
        companyDesc:
          user.userType === IExternalPortalUserType.OUTSOURCER
            ? null
            : user.companyDesc,
        adUser: user.adUser,
        siteId: user.siteId,
        siteDesc: user.siteDesc,
        statusId: tempStatusId,
        statusDesc: tempStatusDesc,
        relationshipStartDate: user.relationshipStartDate,
        relationshipEndDate: user.relationshipEndDate,
        terminationDate: user.terminationDate,
        userId: user.userId,
        companyEmail: user.companyEmail,
        area: user.area,
        manager: user.manager,
        referral: user.referral,
        badge: user.badge,
        badgeRequestDate: user.badgeRequestDate,
        badgeReleaseDate: user.badgeReleaseDate,
        badgeNote: user.badgeNote,
        hasRequestedAD: user.hasRequestedAD,
        hasRequestedDB: user.hasRequestedDB,
        hasRequestedNexiEmail: user.hasRequestedNexiEmail,
        hasRequestedSO: user.hasRequestedSO,
        usernameNexi: user.usernameNexi,
        extensionTicketDate: user.extensionTicketDate,
        terminationTicketDate: user.terminationTicketDate,
        terminationNote: user.terminationNote,
        genericNote: user.genericNote,
        hasRequestedWiFi: user.hasRequestedWiFi,
        externalCompanyId:
          user.userType === IExternalPortalUserType.OUTSOURCER
            ? user.companyId
            : user.externalCompanyId,
        externalCompanyDesc:
          user.userType === IExternalPortalUserType.OUTSOURCER
            ? user.companyDesc
            : user.externalCompanyDesc,
        contractType: user.contractType,
        onSiteRate: user.onSiteRate,
        project: user.project,
        cluster: user.cluster,
        amministratoreSistema: user.amministratoreSistema,
        scadenzaLetteraNomina: user.scadenzaLetteraNomina,
        amministratoreApparSic: user.amministratoreApparSic,
        datiMovEconomiche: user.datiMovEconomiche,
        letteraInviata: user.letteraInviata,
        datiAnagrafici: user.datiAnagrafici,
        noteGenGovernance: user.noteGenGovernance,
        letteraFirmata: user.letteraFirmata,
        amministratoreAppaRete: user.amministratoreAppaRete,
        datiCartePagamento: user.datiCartePagamento,
        noteProfiloAccDb: user.noteProfiloAccDb,
        adterminationTicket: user.adterminationTicket,
        adinitTicket: user.adinitTicket,
        adendDate: user.adendDate,
        fte: user.fte,
        adrenewTicket: user.adrenewTicket,
        idDepoBank: user.idDepoBank ? user.idDepoBank : null,
        mobileNumber: user.mobileNumber,
        mobileNumberVerified: user.mobileNumberVerified,
        vendorUser: user.vendorUser,
      };
      let modifiedUser2 = {
        idExternalPortal: user.id,
        userCode: user.userCode,
        userType: user.userType,
        name: user.name,
        surname: user.surname,
        externalCompanyDesc:
          user.userType === IExternalPortalUserType.OUTSOURCER
            ? user.companyDesc
            : user.externalCompanyDesc,
        companyEmail: user.companyEmail,
        statusIdExternalPortal: tempStatusId,
        status: statusCodeId[tempStatusId as keyof typeof statusCodeId],
        relationshipEndDate: formatDateFromMillisecondsStringToDDMMYYYY(
          user.relationshipEndDate
        ),
        manager: user.managerFullName ? `${user.managerFullName}` : "",
        referral: user.referralFullName ? `${user.referralFullName}` : "",
      };
      modifiedUsers1.push(modifiedUser1);
      modifiedUsers2.push(modifiedUser2);
    });
    let modifiedPayload1 = {
      ...paginationData,
      users: modifiedUsers1,
    };
    let modifiedPayload2 = {
      ...paginationData,
      users: modifiedUsers2,
    };
    return compose(
      immutableSet(
        [USERS_MANAGEMENT, STEP_ONE, LIST_IDENTIFIER],
        modifiedPayload1
      ),
      immutableSet(
        [USERS_MANAGEMENT, STEP_ONE, COMPACTED_USERS],
        modifiedPayload2
      ),
      immutableSet(
        [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
        IResponseState.PENDING
      ),
      immutableSet([USERS_MANAGEMENT, STEP_ONE, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.PAGINATED_USERS_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet([USERS_MANAGEMENT, STEP_ONE, LOADER_IDENTIFIER], false, state),

  [actionTypes.GET_USER_ATTACHMENTS_INFO]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, ATTACHMENTS, LOADER_IDENTIFIER],
      true,
      state
    ),

  [actionTypes.GET_USER_ATTACHMENTS_INFO_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let toAdd: any = [];
    action.payload.forEach((attachment: any) => {
      let attachmentToAdd = {
        ...attachment,
      };
      toAdd.push(attachmentToAdd);
    });
    return compose(
      immutableSet(
        [USERS_MANAGEMENT, STEP_ONE, ATTACHMENTS, LIST_IDENTIFIER],
        toAdd
      ),
      immutableSet(
        [USERS_MANAGEMENT, STEP_ONE, ATTACHMENTS, LOADER_IDENTIFIER],
        false
      )
    )(state);
  },

  [actionTypes.GET_USER_ATTACHMENTS_INFO_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, ATTACHMENTS, LOADER_IDENTIFIER],
      false,
      state
    ),

  [actionTypes.GET_USER_ADMIN_LETTERS_INFO]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, ADMIN_LETTERS, LOADER_IDENTIFIER],
      true,
      state
    ),

  [actionTypes.GET_USER_ADMIN_LETTERS_INFO_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let toAdd: any = [];
    action.payload.forEach((attachment: any) => {
      let attachmentToAdd = {
        ...attachment,
      };
      toAdd.push(attachmentToAdd);
    });
    return compose(
      immutableSet(
        [USERS_MANAGEMENT, STEP_ONE, ADMIN_LETTERS, LIST_IDENTIFIER],
        toAdd
      ),
      immutableSet(
        [USERS_MANAGEMENT, STEP_ONE, ADMIN_LETTERS, LOADER_IDENTIFIER],
        false
      )
    )(state);
  },

  [actionTypes.GET_USER_ADMIN_LETTERS_INFO_FAILURE]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, ADMIN_LETTERS, LOADER_IDENTIFIER],
      false,
      state
    ),

  [actionTypes.RESET_ATTACHMENTS_STATE]: (state: any, action: any) =>
    compose(
      immutableSet(
        [USERS_MANAGEMENT, STEP_ONE, ADMIN_LETTERS, LIST_IDENTIFIER],
        []
      ),
      immutableSet(
        [USERS_MANAGEMENT, STEP_ONE, ATTACHMENTS, LIST_IDENTIFIER],
        []
      )
    )(state),

  [actionTypes.UPDATE_REACTIVATE_RENEW_ADMIN_BODY]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REACTIVATE_RENEW_ADMIN_BODY],
      action.payload,
      state
    ),

  [actionTypes.UPDATE_REACTIVATE_RENEW_MASSIVE_BODY]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REACTIVATE_RENEW_MASSIVE_BODY],
      action.payload,
      state
    ),

  [actionTypes.GET_USERS_VALIDATION_INFO]: (state: any, action: any) =>
    immutableSet([SOCIETY_VALIDATION, USERS, LOADER_IDENTIFIER], true, state),

  [actionTypes.GET_USERS_VALIDATION_INFO_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let mappedResponse1: any[] = [];
    let mappedResponse2: any[] = [];
    action.payload.usersValidation.length > 0 &&
      action.payload.usersValidation.forEach((e: any) => {
        let temp1 = {
          id: e.id,
          type: e.type,
          newObject: e.newObject,
          user: e.user,
        };
        let temp2 = {
          uniqueId: e.id,
          userCodeSocietyValidation: e.user.userCode,
          surname: e.user.surname,
          name: e.user.name,
        };
        mappedResponse1.push(temp1);
        mappedResponse2.push(temp2);
      });
    return compose(
      immutableSet(
        [SOCIETY_VALIDATION, USERS, LIST_IDENTIFIER],
        mappedResponse1
      ),
      immutableSet(
        [SOCIETY_VALIDATION, USERS, COMPACTED_USERS],
        mappedResponse2
      ),
      immutableSet(
        [SOCIETY_VALIDATION, USERS, REQUEST_STATE],
        IResponseState.PENDING
      ),
      immutableSet([SOCIETY_VALIDATION, USERS, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.GET_USERS_VALIDATION_INFO_FAILURE]: (state: any, action: any) =>
    immutableSet([SOCIETY_VALIDATION, USERS, LOADER_IDENTIFIER], false, state),

  [actionTypes.GET_OFFICES]: (state: any, action: any) =>
    immutableSet([OFFICES, LOADER_IDENTIFIER], true, state),

  [actionTypes.GET_OFFICES_SUCCESS]: (state: any, action: any) => {
    let mappedResponse: any[] = [];
    action.payload.length > 0 &&
      action.payload.forEach((e: any) => {
        mappedResponse.push(e);
      });
    return compose(
      immutableSet([OFFICES, LIST_IDENTIFIER], mappedResponse),
      immutableSet([OFFICES, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.GET_OFFICES_FAILURE]: (state: any, action: any) =>
    immutableSet([OFFICES, LOADER_IDENTIFIER], false, state),

  [actionTypes.GET_COMPANIES]: (state: any, action: any) =>
    immutableSet([COMPANIES, LOADER_IDENTIFIER], true, state),

  [actionTypes.GET_COMPANIES_SUCCESS]: (state: any, action: any) => {
    let mappedResponse: any[] = [];
    action.payload.length > 0 &&
      action.payload.forEach((e: any) => {
        mappedResponse.push(e);
      });
    return compose(
      immutableSet([COMPANIES, LIST_IDENTIFIER], mappedResponse),
      immutableSet([COMPANIES, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.GET_COMPANIES_FAILURE]: (state: any, action: any) =>
    immutableSet([COMPANIES, LOADER_IDENTIFIER], false, state),

  [actionTypes.SAVE_SOCIETY_VALIDATION]: (state: any, action: any) =>
    immutableSet(
      [SOCIETY_VALIDATION, USERS, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.SAVE_SOCIETY_VALIDATION_SUCCESS]: (state: any, action: any) =>
    immutableSet(
      [SOCIETY_VALIDATION, USERS, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.SAVE_SOCIETY_VALIDATION_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [SOCIETY_VALIDATION, USERS, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.UPLOAD_ATTACHMENTS_TO_ADMIN_LETTERS]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.UPLOAD_ATTACHMENTS_TO_ADMIN_LETTERS_SUCCESS]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.UPLOAD_ATTACHMENTS_TO_ADMIN_LETTERS_FAILURE]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.UPLOAD_ATTACHMENTS_TO_USERS]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.UPLOAD_ATTACHMENTS_TO_USERS_SUCCESS]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.UPLOAD_ATTACHMENTS_TO_USERS_FAILURE]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.TERMINATE_CONSULTANT]: (state: any, action: any) =>
    compose(
      immutableSet(
        [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
        IResponseState.PENDING
      ),
      immutableSet([USERS_MANAGEMENT, STEP_ONE, FAILED_OPERATIONS], [])
    )(state),

  [actionTypes.TERMINATE_CONSULTANT_SUCCESS]: (state: any, action: any) => {
    let responseState = IResponseState.SUCCESS;
    if (action.payload.error && action.payload.error.length > 0)
      responseState = IResponseState.ERROR;
    return compose(
      immutableSet([USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE], responseState),
      immutableSet(
        [USERS_MANAGEMENT, STEP_ONE, FAILED_OPERATIONS],
        action.payload.error
      )
    )(state);
  },

  [actionTypes.TERMINATE_CONSULTANT_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.TERMINATE_OUTSOURCER]: (state: any, action: any) =>
    compose(
      immutableSet(
        [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
        IResponseState.PENDING
      ),
      immutableSet([USERS_MANAGEMENT, STEP_ONE, FAILED_OPERATIONS], [])
    )(state),

  [actionTypes.TERMINATE_OUTSOURCER_SUCCESS]: (state: any, action: any) => {
    let responseState = IResponseState.SUCCESS;
    if (action.payload.error && action.payload.error.length > 0)
      responseState = IResponseState.ERROR;
    return compose(
      immutableSet([USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE], responseState),
      immutableSet(
        [USERS_MANAGEMENT, STEP_ONE, FAILED_OPERATIONS],
        action.payload.error
      )
    )(state);
  },

  [actionTypes.TERMINATE_OUTSOURCER_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.TERMINATE_SECURITY]: (state: any, action: any) =>
    compose(
      immutableSet(
        [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
        IResponseState.PENDING
      ),
      immutableSet([USERS_MANAGEMENT, STEP_ONE, FAILED_OPERATIONS], [])
    )(state),

  [actionTypes.TERMINATE_SECURITY_SUCCESS]: (state: any, action: any) => {
    let responseState = IResponseState.SUCCESS;
    if (action.payload.error && action.payload.error.length > 0)
      responseState = IResponseState.ERROR;
    return compose(
      immutableSet([USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE], responseState),
      immutableSet(
        [USERS_MANAGEMENT, STEP_ONE, FAILED_OPERATIONS],
        action.payload.error
      )
    )(state);
  },
  [actionTypes.TERMINATE_SECURITY_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.VALIDATE_USERS]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.VALIDATE_USERS_SUCCESS]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.VALIDATE_USERS_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.DISABLE_CONSULTANT]: (state: any, action: any) =>
    compose(
      immutableSet(
        [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
        IResponseState.PENDING
      ),
      immutableSet([USERS_MANAGEMENT, STEP_ONE, FAILED_OPERATIONS], [])
    )(state),

  [actionTypes.DISABLE_CONSULTANT_SUCCESS]: (state: any, action: any) => {
    let responseState = IResponseState.SUCCESS;
    if (action.payload.error && action.payload.error.length > 0)
      responseState = IResponseState.ERROR;
    return compose(
      immutableSet([USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE], responseState),
      immutableSet(
        [USERS_MANAGEMENT, STEP_ONE, FAILED_OPERATIONS],
        action.payload.error
      )
    )(state);
  },

  [actionTypes.DISABLE_CONSULTANT_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.DISABLE_OUTSOURCER]: (state: any, action: any) =>
    compose(
      immutableSet(
        [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
        IResponseState.PENDING
      ),
      immutableSet([USERS_MANAGEMENT, STEP_ONE, FAILED_OPERATIONS], [])
    )(state),

  [actionTypes.DISABLE_OUTSOURCER_SUCCESS]: (state: any, action: any) => {
    let responseState = IResponseState.SUCCESS;
    if (action.payload.error && action.payload.error.length > 0)
      responseState = IResponseState.ERROR;
    return compose(
      immutableSet([USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE], responseState),
      immutableSet(
        [USERS_MANAGEMENT, STEP_ONE, FAILED_OPERATIONS],
        action.payload.error
      )
    )(state);
  },

  [actionTypes.DISABLE_OUTSOURCER_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.BLOCK_USER]: (state: any, action: any) =>
    compose(
      immutableSet(
        [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
        IResponseState.PENDING
      ),
      immutableSet([USERS_MANAGEMENT, STEP_ONE, FAILED_OPERATIONS], [])
    )(state),

  [actionTypes.BLOCK_USER_SUCCESS]: (state: any, action: any) => {
    let responseState = IResponseState.SUCCESS;
    if (action.payload.error && action.payload.error.length > 0)
      responseState = IResponseState.ERROR;
    return compose(
      immutableSet([USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE], responseState),
      immutableSet(
        [USERS_MANAGEMENT, STEP_ONE, FAILED_OPERATIONS],
        action.payload.error
      )
    )(state);
  },

  [actionTypes.BLOCK_USER_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.DELETE_ATTACHMENT]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.DELETE_ATTACHMENT_SUCCESS]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.DELETE_ATTACHMENT_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.RENEW_USER]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.RENEW_USER_SUCCESS]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.RENEW_USER_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.RENEW_USER_ADMIN]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.RENEW_USER_ADMIN_SUCCESS]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.RENEW_USER_ADMIN_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.REACTIVATE_OUTSOURCER]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.REACTIVATE_OUTSOURCER_SUCCESS]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.REACTIVATE_OUTSOURCER_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.REACTIVATE_USER]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.REACTIVATE_USER_SUCCESS]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.REACTIVATE_USER_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.REACTIVATE_CONSULTANT]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.REACTIVATE_CONSULTANT_SUCCESS]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.REACTIVATE_CONSULTANT_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.REACTIVATE_ADMIN]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.REACTIVATE_ADMIN_SUCCESS]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.REACTIVATE_ADMIN_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.UPDATE_USER_INFO]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.UPDATE_USER_INFO_SUCCESS]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.UPDATE_USER_INFO_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.ENABLE_BADGE_TO_USER]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.ENABLE_BADGE_TO_USER_SUCCESS]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.ENABLE_BADGE_TO_USER_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_ONE, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.GET_USER_WITH_ALREADY_EXISTING_FISCAL_CODE]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet([USERS_MANAGEMENT, ADD_USER, LOADER_IDENTIFIER], true),
      immutableSet(
        [USERS_MANAGEMENT, ADD_USER, REQUEST_STATE],
        IResponseState.PENDING
      ),
      immutableSet(
        [USERS_MANAGEMENT, ADD_USER, ALREADY_EXISTING_FISCAL_CODE],
        false
      )
    )(state),

  [actionTypes.GET_USER_WITH_ALREADY_EXISTING_FISCAL_CODE_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let mappedResponse = false;
    action.payload.users.length > 0
      ? (mappedResponse = true)
      : (mappedResponse = false);
    let managers = [] as string[];
    action.payload.users.forEach((user: any) => managers.push(user.manager));
    return compose(
      immutableSet(
        [USERS_MANAGEMENT, ADD_USER, ALREADY_EXISTING_FISCAL_CODE],
        mappedResponse
      ),
      immutableSet([USERS_MANAGEMENT, ADD_USER, LOADER_IDENTIFIER], false),
      immutableSet(
        [USERS_MANAGEMENT, ADD_USER, REQUEST_STATE],
        IResponseState.SUCCESS
      ),
      immutableSet(
        [USERS_MANAGEMENT, ADD_USER, USERS_WITH_SAME_FISCAL_CODE_MANAGER],
        managers
      )
    )(state);
  },

  [actionTypes.GET_USER_WITH_ALREADY_EXISTING_FISCAL_CODE_FAILURE]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet([USERS_MANAGEMENT, ADD_USER, LOADER_IDENTIFIER], false),
      immutableSet(
        [USERS_MANAGEMENT, ADD_USER, REQUEST_STATE],
        IResponseState.ERROR
      ),
      immutableSet(
        [USERS_MANAGEMENT, ADD_USER, USERS_WITH_SAME_FISCAL_CODE_MANAGER],
        []
      )
    )(state),

  [actionTypes.RESET_STATE_EXTERNAL_PORTAL]: (state: any, action: any) =>
    emptyState,

  [actionTypes.GET_EXTERNAL_PORTAL_COMBO_OPTIONS_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let cluster =
      action.payload[0].field === IComboOptionType.CLUSTER
        ? []
        : [...state.comboOptions[CLUSTER]];
    let contractTypology =
      action.payload[0].field === IComboOptionType.CONTRACT_TYPOLOGY
        ? []
        : [...state.comboOptions[CONTRACT_TYPOLOGY]];
    let fte =
      action.payload[0].field === IComboOptionType.FTE
        ? []
        : [...state.comboOptions[FTE]];
    let presence =
      action.payload[0].field === IComboOptionType.PRESENCE
        ? []
        : [...state.comboOptions[PRESENCE]];
    action.payload.forEach((option: any) => {
      if (option.field === IComboOptionType.CLUSTER) cluster.push(option);
      if (option.field === IComboOptionType.CONTRACT_TYPOLOGY)
        contractTypology.push(option);
      if (option.field === IComboOptionType.FTE) fte.push(option);
      if (option.field === IComboOptionType.PRESENCE) presence.push(option);
    });
    return compose(
      immutableSet([COMBO_OPTIONS, CLUSTER], cluster),
      immutableSet([COMBO_OPTIONS, CONTRACT_TYPOLOGY], contractTypology),
      immutableSet([COMBO_OPTIONS, FTE], fte),
      immutableSet([COMBO_OPTIONS, PRESENCE], presence)
    )(state);
  },
  [actionTypes.GET_EXTERNAL_PORTAL_COMBO_OPTIONS_FAILURE]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet([COMBO_OPTIONS, CLUSTER], []),
      immutableSet([COMBO_OPTIONS, CONTRACT_TYPOLOGY], []),
      immutableSet([COMBO_OPTIONS, FTE], []),
      immutableSet([COMBO_OPTIONS, PRESENCE], [])
    )(state);
  },

  [actionTypes.RESET_FISCAL_CODE_CHECK]: (state: any, action: any) =>
    compose(
      immutableSet(
        [USERS_MANAGEMENT, ADD_USER, ALREADY_EXISTING_FISCAL_CODE],
        false
      ),
      immutableSet(
        [USERS_MANAGEMENT, ADD_USER, REQUEST_STATE],
        IResponseState.PENDING
      )
    )(state),

  [actionTypes.EXTERNAL_PORTAL_INSERT_USER]: (state: any, action: any) =>
    compose(
      immutableSet(
        [USERS_MANAGEMENT, ADD_USER, ADD_USER_RESPONSE_STATE],
        IResponseState.PENDING
      ),
      immutableSet(
        [USERS_MANAGEMENT, ADD_USER, ALREADY_EXISTING_FISCAL_CODE],
        false
      ),
      immutableSet(
        [USERS_MANAGEMENT, ADD_USER, REQUEST_STATE],
        IResponseState.PENDING
      )
    )(state),

  [actionTypes.EXTERNAL_PORTAL_INSERT_USER_SUCCESS]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [USERS_MANAGEMENT, ADD_USER, ADD_USER_RESPONSE_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.EXTERNAL_PORTAL_INSERT_USER_FAILURE]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [USERS_MANAGEMENT, ADD_USER, ADD_USER_RESPONSE_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.EXTERNAL_PORTAL_UPDATE_USER]: (state: any, action: any) =>
    compose(
      immutableSet(
        [USERS_MANAGEMENT, STEP_TWO, REQUEST_STATE],
        IResponseState.PENDING
      )
    )(state),

  [actionTypes.EXTERNAL_PORTAL_UPDATE_USER_SUCCESS]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_TWO, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.EXTERNAL_PORTAL_UPDATE_USER_FAILURE]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [USERS_MANAGEMENT, STEP_TWO, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.GET_USER_TYPE_THAT_CAN_BE_CREATED]: (state: any, action: any) =>
    immutableSet([USERS_MANAGEMENT, ADD_USER, LOADER_IDENTIFIER], true, state),
  [actionTypes.GET_USER_TYPE_THAT_CAN_BE_CREATED_SUCCESS]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet([USERS_MANAGEMENT, ADD_USER, LOADER_IDENTIFIER], false),
      immutableSet(
        [USERS_MANAGEMENT, ADD_USER, USER_TYPES_THAT_CAN_BE_CREATED],
        action.payload.type
      )
    )(state),
  [actionTypes.GET_USER_TYPE_THAT_CAN_BE_CREATED_FAILURE]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet([USERS_MANAGEMENT, ADD_USER, LOADER_IDENTIFIER], false),
      immutableSet(
        [USERS_MANAGEMENT, ADD_USER, USER_TYPES_THAT_CAN_BE_CREATED],
        []
      )
    )(state),
  [actionTypes.MANIPOLATE_ORGANIZATIONAL_UNITS]: (state: any, action: any) =>
    immutableSet([USERS_MANAGEMENT, MANIPOLATED_OU], action.payload, state),

  [actionTypes.RESET_REACTIVATE_BODIES]: (state: any, action: any) =>
    compose(
      immutableSet(
        [USERS_MANAGEMENT, STEP_ONE, REACTIVATE_RENEW_MASSIVE_BODY],
        []
      ),
      immutableSet(
        [USERS_MANAGEMENT, STEP_ONE, REACTIVATE_RENEW_ADMIN_BODY],
        []
      )
    )(state),
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    (action.payload.location.pathname === "/welcome" ||
      action.payload.location.pathname === "/external-portal")
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
